import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 relative p-3 bg-gray-100 rounded-md"
}
const _hoisted_2 = { class: "m-0 w-2/3 font-bold" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mb-0 font-bold" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mb-0 font-semibold" }
const _hoisted_9 = { class: "m-0" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "mb-0 font-semibold" }
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = { class: "flex gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "w-1/2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-semibold" }, " Was: ", -1)
const _hoisted_16 = { class: "m-0" }
const _hoisted_17 = { class: "bg-gray-50 p-2 rounded-md" }
const _hoisted_18 = {
  key: 1,
  class: "w-1/2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-semibold" }, " Is: ", -1)
const _hoisted_20 = { class: "m-0" }
const _hoisted_21 = { class: "bg-gray-50 p-2 rounded-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.difference.absolutePath.includes(_ctx.activeTab))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", {
          class: _normalizeClass(`absolute w-1/3 -top-1 right-3 text-xs text-right overflow-hidden ${_ctx.seeEverything ? 'h-full' : 'h-8'}`)
        }, _toDisplayString(_ctx.getNestedBreadcrumbTitles(_ctx.ba, _ctx.difference.absolutePath, false)), 3),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "cursor-pointer w-full",
            onClick: _cache[0] || (_cache[0] = () => _ctx.seeEverything = !_ctx.seeEverything)
          }, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.frage?.titel.en || 'Mangellogik') + " " + _toDisplayString(_ctx.difference.operator), 1)
          ]),
          (_ctx.seeEverything)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.difference.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t("migration.beschreibung")), 1),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.difference.description), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.difference.absolutePath)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t("migration.absoluterPfad")), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.difference.absolutePath), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.difference.identifier)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t("migration.identifier")), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.difference.identifier), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.difference.was)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("p", _hoisted_16, [
                          _createElementVNode("pre", _hoisted_17, "                            " + _toDisplayString(_ctx.difference.was) + "\n" + "\n                        ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.difference.is)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("p", _hoisted_20, [
                          _createElementVNode("pre", _hoisted_21, "                                " + _toDisplayString(_ctx.difference.is) + "\n                            ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}